export const ASSETS = {
  sunny: "https://static.prod-images.emergentagent.com/jobs/ac763fea-6430-4c65-9f28-ce022b5bc27b/images/3e38cda27479fce262f41754abcbcc786dd0b36bd3b50431eda51d1217b527ea.png",
  sunnyHero: "https://static.prod-images.emergentagent.com/jobs/ac763fea-6430-4c65-9f28-ce022b5bc27b/images/727d00267479957c383bb4a1695a90377c89b8f75965911e36f759091967781c.png",
  jesus: "https://static.prod-images.emergentagent.com/jobs/ac763fea-6430-4c65-9f28-ce022b5bc27b/images/1633dbb15bad149e091b04165b0b606d1dfab94c8591e649dd5b8d3985aac3b3.png",
  shepherd: "https://static.prod-images.emergentagent.com/jobs/ac763fea-6430-4c65-9f28-ce022b5bc27b/images/2f3c8c6b80889024063255b8cf96c5ae3b18038db3c83810271f6fd058703b93.png",
};

export const MOODS = [
  { key: "struggling", emoji: "😢", label: "Struggling", color: "#FFA69E" },
  { key: "anxious", emoji: "😟", label: "Worried", color: "#FFD166" },
  { key: "okay", emoji: "😐", label: "Okay", color: "#E8DFF5" },
  { key: "better", emoji: "🙂", label: "Good", color: "#D8F3DC" },
  { key: "grateful", emoji: "😄", label: "Great!", color: "#A0E7B0" },
  { key: "excited", emoji: "🤩", label: "Excited", color: "#FFD166" },
  { key: "proud", emoji: "😊", label: "Proud", color: "#FFB5A7" },
  { key: "peaceful", emoji: "😌", label: "Peaceful", color: "#CDEAFE" },
  { key: "loved", emoji: "🥰", label: "Loved", color: "#FFD8E4" },
  { key: "hopeful", emoji: "🌟", label: "Hopeful", color: "#FFE08A" },
  { key: "thankful", emoji: "🙏", label: "Thankful", color: "#B7E4C7" },
  { key: "brave", emoji: "🦁", label: "Brave", color: "#FFC971" },
  { key: "silly", emoji: "😜", label: "Silly", color: "#FCD5CE" },
];

export const MOOD_SCORE = {
  struggling: 1, anxious: 2, okay: 3, better: 4, grateful: 5,
  excited: 5, proud: 5, peaceful: 5, loved: 5, hopeful: 5, thankful: 5, brave: 5, silly: 5,
};

export const MOOD_REPLIES = {
  struggling: "It's okay to feel sad, friend. God is right here with you, and so am I. 💛",
  anxious: "Take a slow, deep breath. You are safe, and you are not alone. 🌬️",
  okay: "Thanks for sharing how you feel. Every feeling is okay. 🌈",
  better: "Yay! I'm so glad you're feeling good today. Keep shining! ✨",
  grateful: "Wonderful! A thankful heart makes the day even brighter! 🌟",
  excited: "Yay! Your joy makes Sunny's heart sparkle! \"This is the day the Lord has made; let us be glad!\" 🌟 (Psalm 118:24)",
  proud: "Way to go, friend! God is so proud of you, and so am I. Keep it up! 😊",
  peaceful: "Mmm, what a calm and cozy feeling. \"My peace I give to you,\" said Jesus. 😌 (John 14:27)",
  loved: "You ARE so loved — by your family, by Sunny, and by God most of all! 🥰 (1 John 3:1)",
  hopeful: "I love your hopeful heart! God has good and bright plans just for you. 🌟 (Jeremiah 29:11)",
  thankful: "A thankful heart makes everything brighter! \"Give thanks to the Lord, for He is good.\" 🙏 (Psalm 107:1)",
  brave: "Roar! You are brave and strong. \"Be strong and courageous, for the Lord your God is with you!\" 🦁 (Joshua 1:9)",
  silly: "Hehe! Giggles are a gift from God. A happy heart is good medicine! 😜 (Proverbs 17:22)",
};
